interface IContractTemplate {
    contractTemplateId: string;
    createDateUTC: Date;
    updateDateUTC: Date;
    name: string;
    body: string;
    contractTemplateKey: string;
    status: string;
}

export class ContractTemplate {
    contractTemplateId: string;
    createDateUTC: Date;
    updateDateUTC: Date;
    name: string;
    body: string;
    contractTemplateKey: string;
    status: string;

    constructor();
    constructor(object: IContractTemplate);
    constructor(object?: any) {
        this.contractTemplateId = object && object.contractTemplateId || null;
        this.name  = object && object.applicationnameStatus || null;
        this.createDateUTC = object && object.createDateTime || null;
        this.updateDateUTC = object && object.updateDateTime || null;
        this.body = object && object.body || null;
        this.contractTemplateKey = object && object.contractTemplateKey || null;
        this.status = object && object.status || null;
    }
}
